<template>
    <v-container>
        <div style="padding:10px; border-radius: 5px; background-color: #555; color: white;">
           Work Surface
        </div>    
        <br>  
        <div style="padding:10px; border-radius: 5px; background-color: #555; color: white;">
            <span v-for="(content, index) in contents" :key="content['id']">
               {{ section }}.{{ index + 1 }} {{ content.question }} <br>
               Answer: {{ forms.surface_score[index] ? 'Yes' : 'No' }} <br>
               Comment: {{ forms.surface_comment[index] }} <br> <br>
            </span>
        </div> 
    </v-container>
</template>
<script>
import db from '@/components/firebase.init';
import Scale from '@/components/Scale';
export default {
    props:['section','forms'],
    data(){
        return{
          contents:[
                {
                    question: "Is there adequate space for required task & equipment?",
                    parts: ['General']
                },
                {
                    question: "Does the workstation height fits the task (writing, reading,precise work – 5cm above elbow)?",
                    parts: ['Elbow']
                },
                {
                    question: "Is the workstation height appropriate for typing (elbow height with arms dangling on the sides)?",
                    parts: ['Elbow']
                },
                {
                    question: "Are heavier work tasks just below elbow height?",
                    parts: ['Elbow']

                },
                {
                    question: "Can the employee move easily to complete work tasks without awkward postures or positioning?",
                    parts: ['Back', 'Neck']
                },
                {
                    question: "Is there appropriate leg room under the work surface for knees(>46 cm) and feet (>61cm)?",
                    parts: ['Knee']
                }
            ]
        }
    },
    methods:{
        initializeComment(){
            for(var i = 0; i < this.contents.length; i++){
                this.surface_comment[i] = "";
            }
        }
    },  
    components:{
        'scale' : Scale
    },
    mounted(){
        this.initializeComment();
    }
}
</script>

